import $ from "jquery";
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import PostLoginGetApi from '../../../components/Api/PostLoginGetApi';
import PostLoginPostApi from '../../../components/Api/PostLoginPostApi';
import { SUPER_ADMIN, USER } from "../ConstRole/ConstRole";
import Container from './../../../utilities/Container';
const cards = { border: '1px solid #666', display: 'block', paddingInline: "10px", paddingBlock: "5px", cursor: "move" };

const SortCompany = (props) => {

    const [companyList, setCompanyList] = useState([]);
    const [isRefresh, setIsRefresh] = useState(0);
    const [userProfile, setUserProfile] = useState({});


    useEffect(() => {
        setUserProfile(props?.userProfile?.user_type);
    }, [props]);


    const [reqParam, setReqParam] = useState({
        page: 1,
    });

    
    // Company List
    useEffect(() => {
        PostLoginGetApi("company-position", reqParam, 3).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setCompanyList(responseData["data"]);
                }
            }
        }).catch((err) => {
            console.log(err);
        });

    }, [isRefresh, reqParam]);


    const updateSortOrder = async () => {
        let company_arr = [];

        $(".company_id").each((i)=>{
            company_arr[i] = $(".company_id").eq(i).val();
        });

        // Now call API to save the updated sorted lists
        await PostLoginPostApi("company-position/update", JSON.stringify({"company_id": company_arr}), 3).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setIsRefresh((prev)=> {return prev+1} );
                    toast.success(responseData["messages"].toString());
                    return;
                }

                toast.error(responseData["message"].toString() ?? responseData["messages"].toString() ?? "A problem occur. Please try again." );
            }

        }).catch((err) => {
            console.log(err);
        })
    }


    if (userProfile !== SUPER_ADMIN && userProfile !== USER) {
        return (<>
            <table className="custom-details-table w-full mt-0 mb-2">
                <tbody>
                    <tr>
                        <td className="font-semibold text-base">
                            You do not have any access !
                        </td>
                    </tr>
                </tbody>
            </table>
        </>);
    }

    return (
        <div className="custom-container w-full font-montserrat flex -mt-4">

            {/** Left Side */}

            <div className="custom-container-left float-left custom-scroll-auto min-w-[80%] w-full pr-3 pb-20 text-justify" style={{ boxShadow: "3px 0 0px 0px rgb(0 0 0 / 1%)" }}>

                <div className="text-justify rounded-[5px] pb-0 pt-3 static">
                    <div className="w-2/3 float-left">
                        <h6 className="text-xl px-4 font-medium pb-0 pl-0 pt-3">Here’s your sorted companies based on display position</h6>
                    </div>
                    
                    <div className="w-1/3 h-[40px] pt-2 float-left text-right justify-end flex items-center">
                        <button type="button" onClick={updateSortOrder} className="text-md border-[#00D632] border-2 rounded hover:bg-[#00D632] hover:text-white hidden" style={{padding: "9px 20px", display: "inline-block"}} >Save Sorted Order</button>
                    </div>
                </div>


                {/* DATA TABLE */}
                <div className="flex flex-col w-full pt-6">
                    <div className='-m-1.5 overflow-x-auto pt-0'>
                        <div className='p-1.5 min-w-full inline-block align-middle'>

                            {(companyList.length) > 0 && 
                                <Container id="container">
                                    {companyList.map((data, key) => (
                                        <div draggable="true" style={cards} key={key} className="hover:bg-gray-100">
                                            <input type="hidden" className="company_id" name="company_id[]" value={data.company_id} />
                                            <span className='w-10 pl-2 h-full block float-left'>
                                                <strong className="text-sm">{data.position}</strong>
                                            </span>
                                            <span>
                                                <span className='w-[750px] block float-left'>
                                                    <Link to={`/dashboard/company-details/${data.company_id}`} className="text-[#0774E9] " target="_blank" >{data.company_name}</Link>
                                                </span>
                                                
                                                <span className='w-[300px] block float-left'>
                                                    {data.category_name ?? ""}
                                                </span>

                                                {data.total_category > 0 && <><strong>{data.total_category}</strong> categories, </> }
                                                {data.total_item > 0 && <><strong>{data.total_item}</strong> items, </> }
                                                {data.total_brand > 0 && <><strong>{data.total_brand}</strong> brands, </> }
                                                {data.total_voucher > 0 && <><strong>{data.total_voucher}</strong> vouchers </> }
                                                &nbsp;

                                            </span>
                                        </div>
                                    ))}
                                </Container>
                            }

                            
                        </div>
                    </div>
                </div>


            </div>

            
        </div>
    );
};

export default SortCompany;